<template>
  <div class="my-tab1-box">
    <slot></slot>
  </div>
</template>
<script>
// <Tr1></Tr1>
export default {
  name: 'TabBox1',
  props: {

  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.my-tab1-box{
  // width: 131px;

}
</style>
